<template>
  <div class="page page-About" :class="{ loaded: isLoaded}">

    <div class="content">
      About
    </div>

  </div>
</template>

<script>
  import {loader} from '../mixins/loader';
  import {isMobile} from '../mixins/isMobile';
  import {functions} from '../mixins/functions';

  export default {
    name: 'About',
    mixins: [loader, isMobile, functions],

    data() {
      return {
        pageData: {page: 'About'},
      }
    },

    deactivated() {
      this.isLoaded = false;
    },

    //activated() {
    mounted() {
      var _t = this;

      if (_t.$store.state.pagesLoaded.App && _t.$store.state.pagesLoaded.About) {
        _t.onActivated();
      } else {
        //_t.$store.commit('loaderON');

        _t.$store.subscribe((mutation, state) => {
          if (mutation.type === 'pageLoaded' && mutation.payload.page == 'About') {
            _t.onActivated();
          }
        });
      }
    },

    created(){
      this.$store.dispatch('loadData', {
        page: 'About'
      });
    },

    methods: {
      onActivated() {
        var _t = this;

        _t.pageLoaded();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/About.vue